import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./style/nav-bar.css"; // Importa il file CSS
import Logo from "../atoms/logo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

	return (
		<nav>
			<Link to="/" className="nav-link-logo-mb">
				<Logo />
			</Link>
			<ul className={mobileMenuOpen ? "open" : ""}>
				<li>
					<NavLink to="/about">About</NavLink>
				</li>
				<li>
					<Link
						to="https://www.1stdibs.com/creators/botta-gioielli/jewelry/"
						target="_blank"
					>
						Shop
					</Link>
				</li>
			</ul>
			<Link to="/" className="nav-link-logo-dk">
				<Logo />
			</Link>
			<ul className={mobileMenuOpen ? "open" : ""}>
				<li>
					<NavLink to="/new-in">New In</NavLink>
				</li>

				<li>
					<NavLink to="/contacts" className="left-link">
						Contact us
					</NavLink>
				</li>
				{/* <Language /> */}
			</ul>
			<div
				className="mobile-menu"
				onClick={() => {
					setMobileMenuOpen(!mobileMenuOpen);
				}}
			>
				<FontAwesomeIcon icon={faBars} className="burger" />
			</div>
		</nav>
	);
};

export default Navbar;
